// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import firebase from 'firebase'
import VueHead from 'vue-head'

Vue.use(VueHead)

Vue.config.productionTip = false
var firebaseConfig = {
  apiKey: 'AIzaSyBIyYEcMVYB8mI8yVQfykeIlEn0EkZaxoA',
  authDomain: 'tominagatile.firebaseapp.com',
  projectId: 'tominagatile',
  storageBucket: 'tominagatile.appspot.com',
  messagingSenderId: '411849188849',
  appId: '1:411849188849:web:46097a9e7ef1ecdf9cd050',
  measurementId: 'G-S0CV88ZBBW'
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)
firebase.firestore().settings({ ignoreUndefinedProperties: true })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js